import { useQuery } from '@tanstack/react-query';
import { statsApi } from './api';

const STATS_QUERY_KEY = 'stats';

/**
 * Get dashboard statistics
 */
export function useDashboardStats() {
  return useQuery({
    queryKey: [STATS_QUERY_KEY, 'dashboard'],
    queryFn: () => statsApi.getDashboardStats(),
    staleTime: 30 * 1000, // Cache for 30 seconds
  });
}
